import { Route, Routes } from "fusion-plugin-react-router";
import { LiveChatScript } from "./shared/utils/globalScripts";
import { Helmet } from "fusion-plugin-react-helmet-async";
import { overrideFontStyles } from "./shared/utils/overrideFonts";
import { assetUrl } from "fusion-core";

// Auth & Error
import UberAuthRedirect from "./pages/UberAuthRedirect";
import UberAuthCallback from "./pages/UberAuthCallback";
import ErrorPage from "./pages/ErrorPage";
import NotFound from "./pages/NotFound";
import BlockedAction from "./pages/BlockedAction";

// Portal
import LandingLayout from "./features/portal/pages/dashboard/LandingLayout";
import HomePage from "./features/portal/pages/dashboard/HomePage";
import ContactPage from "./features/portal/pages/dashboard/ContactPage";
import Support from "./features/portal/pages/support/support";
import PortalDocuments from "./features/portal/pages/documents/PortalDocuments";
import ReportClaimLayout from "./features/portal/pages/reportClaim/reportClaimLayout";
import ProtectedRoute from "./shared/components/protectedRoute";
import TaxiJourney from "./pages/TaxiJourney";

// Admin
import Login from "./features/admin/Login";
import Dashboard from "./features/admin/Dashboard";
import DashboardHome from "./features/admin/pages/DashboardHome";
import CategoryManagement from "./features/admin/pages/CategoryManagement";
import SchemeFeatureManagement from "./features/admin/pages/SchemeFeatureManagement";
import SchemeFeatureEdit from "./features/admin/pages/SchemeFeatureEdit";
import UserManagement from "./features/admin/pages/UserManagement";
import AddonsManagement from "./features/admin/pages/AddonsManagement";

// Buy
import TbPaymentSuccess from "./features/buy/pages/tbPaymentSuccess";
import TbPclAgreementPage from "./features/buy/pages/TbPclAgreementPage";
import TbPClAgreementConfirm from "./features/buy/pages/tbPclAgreementConfirm";
import TbPClAgreementCancel from "./features/buy/pages/tbPclAgreementCancel";
import TbPclAgreementDecline from "./features/buy/pages/tbPclAgreementDecline";
import TbPClAgreementError from "./features/buy/pages/tbPclAgreementError";
import ErrorBoundary from "./shared/components/ErrorBoundary";

const root = (
  <ErrorBoundary>
    <Helmet>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
      />
      <link rel="icon" href={assetUrl("./assets/favicon/favicon.svg")} />
      <link rel="stylesheet" href={assetUrl("./styles/main.css")} />
      <script src="https://code.jquery.com/jquery-3.5.0.js"></script>
      <script src={assetUrl("./features/buy/dist/rxp-js.js")}></script>
      <style>{overrideFontStyles}</style>
    </Helmet>

    <LiveChatScript />
    <Routes>
      {/* Public */}
      <Route exact path="/" element={<UberAuthRedirect />} />
      <Route exact path="/login/uber" element={<UberAuthCallback />} />
      <Route exact path="/error" element={<ErrorPage />} />
      <Route exact path="/blocked-action" element={<BlockedAction />} />

      {/* Protected */}
      <Route element={<ProtectedRoute />}>
        <Route exact path="/taxi/quote" element={<TaxiJourney />} />
        <Route path="/landing" element={<LandingLayout />}>
          <Route index element={<HomePage />} />
          <Route path="contact" element={<ContactPage />} />
        </Route>
        <Route exact path="/support" element={<Support />} />
        <Route exact path="/claim" element={<ReportClaimLayout />} />
        <Route exact path="/documents" element={<PortalDocuments />} />
      </Route>

      {/* Admin */}
      <Route path="/admin" element={<Login />} />
      <Route path="/admin/dashboard" element={<Dashboard />}>
        <Route index element={<DashboardHome />} />
        <Route path="categories" element={<CategoryManagement />} />
        <Route path="scheme-features" element={<SchemeFeatureManagement />} />
        <Route
          path="scheme-features/edit/:id"
          element={<SchemeFeatureEdit />}
        />
        <Route path="scheme-features/new" element={<SchemeFeatureEdit />} />
        <Route path="users" element={<UserManagement />} />
        <Route path="addons" element={<AddonsManagement />} />
      </Route>

      {/* Buy */}
      <Route exact path="/agreement/pcl" element={<TbPclAgreementPage />} />
      <Route
        exact
        path="/agreement/pcl/error"
        element={<TbPClAgreementError />}
      />
      <Route
        exact
        path="/agreement/pcl/cancel"
        element={<TbPClAgreementCancel />}
      />
      <Route
        exact
        path="/agreement/pcl/confirm"
        element={<TbPClAgreementConfirm />}
      />
      <Route
        exact
        path="/agreement/pcl/decline"
        element={<TbPclAgreementDecline />}
      />
      <Route exact path="/payment/success" element={<TbPaymentSuccess />} />

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  </ErrorBoundary>
);

export default root;
